import { motion } from '@/app/utils/motion'
import type { FunctionalComponent } from 'preact'

export const Motion: FunctionalComponent<{
  id?: string
  class?: string
  initialX?: number
  initialO?: number
  duration?: number
}> = props => {
  return (
    <motion.div
      id={props.id}
      class={props.class}
      initial={{ x: props.initialX ?? -5, opacity: props.initialO ?? 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      transition={{ duration: props.duration ?? 0.3, ease: 'easeOut' }}
      viewport={{ once: true }}
    >
      {props.children}
    </motion.div>
  )
}
